import { SET_IS_OPEN_SMART_DOCUMENT_MODAL } from '../actionTypes';
import { templateDocumentsActions } from '../reducer';

export default (value) =>
    templateDocumentsActions[SET_IS_OPEN_SMART_DOCUMENT_MODAL](value);
